import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type SrPinDotsEstado = 'normal' | 'error' | 'validando' | 'tenue';

/**
 * sr-pin-dots · Los 4 puntos del PIN. Nunca muestran el número: solo cuántos se llevan.
 *
 * Diseño: docs/servicio-tecnico/diseno/SoftRent Modo Tecnico PIN.html (`.pn-ds`).
 *
 *   <sr-pin-dots [llenos]="digitos().length" estado="error" />
 */
@Component({
  selector: 'sr-pin-dots',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pd" [attr.data-estado]="estado()" role="img" [attr.aria-label]="etiqueta()">
      @for (i of puntos; track i) {
        <span class="pd__dot" [class.pd__dot--lleno]="i < llenos()"></span>
      }
    </div>
  `,
  styles: `
    .pd { display: flex; gap: 18px; padding-block: 6px; }
    .pd__dot { width: 34px; height: 34px; border-radius: 50%; border: 3px solid var(--ink-2); background: transparent; }
    .pd__dot--lleno { background: var(--ink); border-color: var(--ink); }
    .pd[data-estado='error'] .pd__dot { border-color: var(--danger); border-style: dashed; }
    .pd[data-estado='tenue'] .pd__dot { border-color: var(--hairline-strong); }
    .pd[data-estado='validando'] .pd__dot--lleno { animation: pd-pulso 900ms ease-in-out infinite; }
    @keyframes pd-pulso { 50% { opacity: .35; } }
    @media (prefers-reduced-motion: reduce) { .pd[data-estado='validando'] .pd__dot--lleno { animation: none; } }
    @media (max-width: 699px) { .pd__dot { width: 30px; height: 30px; } }
  `,
})
export class SrPinDotsComponent {
  /** Cuántos números lleva (0 a 4). */
  readonly llenos = input(0);
  readonly estado = input<SrPinDotsEstado>('normal');

  protected readonly puntos = [0, 1, 2, 3];
  protected readonly etiqueta = computed(() => `${this.llenos()} de 4 números`);
}
